import { memo } from "react";
import { styled } from "@mui/material";
import { default as TextFieldMUI } from "@mui/material/TextField";

const TextField = memo(({ children, inputProps, maxLength = 50, ...props }: any) => {
  const inputPropsWithMaxLength = { ...inputProps, maxLength };
  const newProps = inputProps
    ? { ...props, inputProps: { ...inputPropsWithMaxLength } }
    : { ...props, inputProps: { maxLength } };
  return (
    <TextFieldStyled fullWidth {...newProps}>
      {children}
    </TextFieldStyled>
  );
});

export default TextField;

const TextFieldStyled = styled(TextFieldMUI)`
  & .css-1nrr2bg-MuiFormLabel-root-MuiInputLabel-root,
  .css-1bn1lqm-MuiFormLabel-root-MuiInputLabel-root {
    color: ${({ theme }) => theme.palette.text.disabled};
  }
`;
